<template lang="">
  <validation-observer ref="cessionaria-modal" tag="div">
    <b-row>
      <b-col md="6">
        <b-form-group label="CNPJ" label-for="cnpj">
          <validation-provider #default="{ errors }" name="CNPJ" rules="required|cnpj">
            <Cleave
              id="cnpj"
              type="text"
              placeholder="##.###.###/####-##"
              v-model="data.cnpj"
              :raw="false"
              :options="cleave.cnpj"
              class="form-control"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Nome" label-for="name">
          <validation-provider #default="{ errors }" name="Nome" rules="required">
            <b-form-input id="name" type="text" placeholder="Nome" v-model="data.name" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="4">
        <b-form-group label="Nome do responsável" label-for="responsible">
          <validation-provider #default="{ errors }" name="Nome do responsável" rules="required">
            <b-form-input id="responsible" type="text" placeholder="Nome do responsável" v-model="data.responsible" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label="E-mail Responsável" label-for="email">
          <validation-provider #default="{ errors }" name="E-mail" rules="required|email">
            <b-form-input id="email" type="email" placeholder="email@responsavel.com" v-model="data.email" />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label="Telefone Responsável" label-for="phone">
          <validation-provider #default="{ errors }" name="Telefone" rules="required">
            <Cleave
              id="phone"
              v-model="data.phone"
              class="form-control"
              :raw="false"
              :options="cleave.phone"
              placeholder="Telefone"
              rules="required"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="text-right mt-3">
      <b-button variant="success" @click="mode === 'edit' ? handleEdit() : handleCreate()">
        {{ mode === 'edit' ? 'Editar' : 'Salvar' }}
      </b-button>
    </div>
  </validation-observer>
</template>
<script>
  import { FormWizard } from 'vue-form-wizard'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import Cleave from 'vue-cleave-component'

  import { required } from '@validations'
  import useJwt from '@/auth/jwt/useJwt'

  export default {
    components: {
      FormWizard,
      ValidationProvider,
      ValidationObserver,
      Cleave,
    },
    props: {
      handleClose: {
        type: Function,
        required: true,
      },
      item: {
        type: Object,
        required: false,
      },
      mode: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        required,
        cleave: {
          cnpj: {
            delimiters: ['.', '.', '/', '-'],
            numericOnly: true,
            blocks: [2, 3, 3, 4, 2],
          },
          phone: {
            numericOnly: true,
            delimiters: ['(', ')', ' ', '-'],
            blocks: [0, 2, 0, 5, 4],
          },
        },

        data: {
          cnpj: null,
          name: null,
          responsible: null,
          email: null,
          phone: null,
        },
      }
    },
    mounted() {
      if (this.item) {
        this.data = { ...this.item }
      }
    },

    methods: {
      handleCreate() {
        this.$refs['cessionaria-modal'].validate().then((success) => {
          if (success) {
            useJwt
              .post('cessionaria', this.data)
              .then(() => {
                this.$message.success('Cessionária cadastrada com sucesso!')
                this.handleClose()
              })
              .catch((error) => {
                if (error.response.status === 409) {
                  this.$message.error('CNPJ já cadastrado!')
                  return
                }
                this.$message.error('Erro ao cadastrar cessionária!')
              })
          }
        })
      },
      handleEdit() {
        this.$refs['cessionaria-modal'].validate().then((success) => {
          if (success) {
            useJwt
              .put(`cessionaria/${this.item.id}`, this.data)
              .then(() => {
                this.$message.success('Cessionária editada com sucesso!')
                this.handleClose()
              })
              .catch((error) => {
                this.$message.error('Erro ao editar cessionária!')
              })
          }
        })
      },
    },
  }
</script>
<style lang=""></style>
